<template>
  <div>
    <rdvs-light-list :rdvs="userRdvs"></rdvs-light-list>
  </div>
</template>

<script>
import { User } from '@/mixins'

export default {
  name: 'UserRdvsList',
  components: {
    RdvsLightList: () => import('@/components/utils/list/RdvsLightList')
  },
  mixins: [User],
  props: {
    propsTab: String
  }
}
</script>
